import useStore from "../../../store"
import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { HappyButton, NeutralButton } from "../../common/Buttons"
import { useTranslation } from "react-i18next"
import useUserType from "../../../hooks/useUserType"
import FormInput from "../../common/FormInput"
import SelectDropdown from "../../common/SelectDropdown"

export default function BBManualEntry({ formValues, setFormValues, setIsManualEntry }) {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { isDealer } = useUserType()
  const setNAPBlackbook = useStore((state) => state.setNAPBlackbook)
  const resetNAPSlice = useStore((state) => state.resetNAPSlice)
  const dealer = useStore((state) => state.dealer)
  const requiredFields = ['vin', 'mileage', 'model_year', 'make', 'model']
  const [isErrored, setIsErrored] = useState(false)

  const handleSubmit = async (e) => {
    if (requiredFields.some((field) => !formValues[field] || formValues[field].toString().trim().length === 0)) {
      setIsErrored(true)
    } else {
      resetNAPSlice()
      setNAPBlackbook({...formValues, isManualEntry: true })
      navigate('/nap')
    }
  }

  const displayRequestFloorTitle = () => {
    if (isDealer) {
      return t('Request Floor')
    }

    return `Request Floor for ${dealer?.attributes.name}`
  }

  return(
    <div className="w-full p-2 mb-2 bg-grey-900 rounded">
      <div className="sticky top-0 left-0 z-0 bg-grey-900 pb-2">
        <h3 className="font-header font-semibold text-md text-green">{displayRequestFloorTitle()}</h3>
      </div>
      <form
        onSubmit={handleSubmit}
        className={`flex flex-col ${isDealer && 'w-3/4'} mt-2 mx-1`}
      >
        <FormInput
          title="VIN"
          value={formValues.vin}
          styles="bg-grey-900"
          onChange={(e) => setFormValues({ ...formValues, vin: e.target.value })}
          onClick={() => setIsErrored(false)}
        />

        <label className="text-sm text-grey-300 my-1">
          {t('Mileage')}
          <input
            type="number"
            value={formValues.mileage}
            aria-label="mileage"
            name="mileage"
            title="mileage"
            className="w-full text-md text-grey-100 p-0.5 bg-grey-900 border-solid border-2 border-grey-700 focus:border-grey-300 focus:ring-0 rounded"
            onChange={(e) => setFormValues({ ...formValues, mileage: e.target.value })}
            onClick={() => setIsErrored(false)}
          />
        </label>

        <SelectDropdown
          title={t('Year')}
          options={Array.from({ length: new Date().getFullYear() - 1920 }, (_, i) => new Date().getFullYear() - i)}
          selectedItem={formValues.model_year}
          setSelectedItem={(item) => setFormValues({ ...formValues, model_year: item })}
          displaySelectedItem={(item) => item}
          onClick={() => setIsErrored(false)}
          label="Year"
          defaultText="Select a year"
        />


        <FormInput
          title={t('Make')}
          value={formValues.make}
          styles="bg-grey-900"
          onChange={(e) => setFormValues({ ...formValues, make: e.target.value })}
          onClick={() => setIsErrored(false)}
        />

        <FormInput
          title={t('Model')}
          value={formValues.model}
          styles="bg-grey-900"
          onChange={(e) => setFormValues({ ...formValues, model: e.target.value })}
          onClick={() => setIsErrored(false)}
        />

        <div className="text-fpx-red text-sm h-4">
          {isErrored && 'All fields are required'}
        </div>
        <HappyButton text={t("Start Floor Request")} onClick={handleSubmit} style="my-4 w-1/2" />
        <NeutralButton text="Standard VIN Entry" onClick={() => setIsManualEntry(false)} />
      </form>
    </div>
  )
}